/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_TitleInputs */

const cs_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založit účet`)
};

const en_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Auth_Signup_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title = /** @type {((inputs?: Auth_Signup_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_title(inputs)
	return cs_auth_signup_title(inputs)
});